<template>
  <div>
    <CRow>
      <CCol md="12" lg="12" xl="12" xxl="12" xs="12" sm="12">
        <CTableWrapper
          :items="data"
          :fields="fields"
          hover
          :striped="true"
          :border="true"
          small
          fixed
          caption="Lista de Categorias"
          icon="fas fa-coins"
          btn_name="Categoria"
          @mtdBack="mtdBack"
          @show_modal="mtd_open_modal"
          @action_edit="mtd_show"
          @action_delete="mtd_delete"
          :size="'md'"
          :button_new="true"
          :actions="true"
          :withActions="'2%'"
          :buttonEdit="true"
          :buttonDelete="true"
        />
      </CCol>
    </CRow>
    <!-- modal -->
    <CModalForm
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'md'"
      :title="modal.title"
      :button="cp_button"
      :show.sync="modal.modal_form"
      @mtd_action="mtd_action"
      :color="'info'"
      :centered="true"
    >
      <CRow class="flex">
        <CCol sm="12">
          <CInput
            label="Nombre"
            placeholder="Digite nombre"
            v-model="categories.name"
          />
        </CCol>
        
        <!-- <CCol sm="12">
          <CInput
            label="Correo"
            placeholder="Digite correo"
            v-model="client.email"
            @input="validateEmail(client.email)"
          />
          <span v-if="errors.email" class="text-danger">{{
            errors.email
          }}</span>
        </CCol> -->
        <!-- <CCol sm="12">
          <CInput
            label="Dirección"
            placeholder="Digite dirección"
            v-model="client.address"
          />
        </CCol> -->
        <!-- <CCol sm="12">
          <CInput
            type="date"
            label="Fecha de Nac."
            placeholder="Digite nombre"
            v-model="client.fech_nacimiento"
          />
        </CCol> -->
        <CCol v-if="modal.action != 'store'" sm="12">
          <label for="">Estado</label>
          <CSwitchVue
            :key="componentKey"
            @changeSwitch="changeSwitch"
            class="mx-1 pl-2 pt-2"
            :checked="categories.state == 1 ? true : false"
            color="success"
            variant="opposite"
            shape="pill"
            v-bind="labelIcon"
          />
        </CCol>
      </CRow>
    </CModalForm>

    <!-- modal delete -->
    <cModalDelete
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'md'"
      :title="'Borrar Grupo'"
      :show.sync="modal_delete.boo"
      @mtd_commit="mtd_commit"
      :centered="true"
      :item="modal_delete.item"
    />
  </div>
</template>

<script>
const fields = [
  { key: "index", label: "Id", _style: "width:1%" },
  { key: "name", label: "Nombre", _style: "width:20%;" },
  { key: "status", label: "Estado", _style: "width:5%;" },
];

import CTableWrapper from "../../shared/datatable/Table.vue";
import CModalForm from "../../shared/modals/cModalForm.vue";
import cModalDelete from "../../shared/modals/cModalDelete.vue";
import { mapActions } from "vuex";
import CSwitchVue from "../../shared/switch/CSwitch.vue";

export default {
  components: { CTableWrapper, CModalForm, cModalDelete, CSwitchVue },
  data() {
    return {
      prefix: "categories",
      fields,
      data: [],
      modal: {
        action: "",
        title: "",
        modal_form: false,
      },
      categories: {
        id: "",
        name: "",
        state: 0,
      },
      errors: {
        name: "",
      },
      modal_delete: {
        boo: false,
        item: [],
      },
      labelIcon: {
        labelOn: "\u2713",
        labelOff: "\u2715",
      },
      componentKey: 0,
    };
  },
  computed: {
    cp_button: function () {
      return !(this.categories.name !== "");
    },
  },
  created() {
    this.mtd_getdata();
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtd_getdata: function () {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix ,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.data = response.data;
          let index = 1;
          this.data.forEach((arr) => {
            arr.index = index;
            index++;
          });
        })
        .catch((errors) => {
          this.errorsBackend = errors;
          this.$emit("error", this.event);
        });
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    mtdBack: function () {
      this.$emit("mtdBack");
    },
    mtd_open_modal: function (boo, action) {
      this.modal.modal_form = boo;
      this.modal.action = action;
      action == "store"
        ? (this.modal.title = "Nuevo(a) Categoria")
        : (this.modal.title = "Editar Categoria");
      if (action == "store") {
        this.categories = {
          id: "",
          name: "",
          state: "",
        };
      } else {
        this.categories = this.categories;
      }
      if (this.modal.action != "store") {
        this.componentKey += 1;
      }
    },
    mtd_action: function () {
      this.post({
        url: `${this.$store.getters.get__url}/${this.prefix}/${this.modal.action}`,
        token: this.$store.getters.get__token,
        params: this.categories,
      })
        .then((response) => {
            console.log("respuesta",response);
          if (response.data.state == 1) {
            Swal.fire({ title: "Categoria ya registrado", icon: "warning" });
          } else if (response.statusCode == 200) {
            const message =
              this.modal.action == "store"
                ? "REGISTRADO CORRECTAMENTE"
                : "EDITADO CORRECTAMENTE";
            const color = "success";
            if (this.modal.action == "store") {
              this.mtd_getdata();
            } else {
              this.data = this.data.map((element) =>
                element.Id === response.data[0].Id
                  ? { ...element, ...response.data[0] }
                  : element
              );
              this.componentKey += 1; // Forzar re-renderización
            }
            this.modal = { action: "", title: "", modal_form: false };
            Swal.fire({
              title: message,
              icon: color,
            });
          }
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "warning",
          });
        });
    },
    mtd_show: function (id) {
      this.get({
        url:
          this.$store.getters.get__url + "/" + this.prefix + "/" + id + "/show",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.categories = response;
          this.mtd_open_modal(true, "update");
        })
        .catch((errors) => {});
    },
    mtd_delete: function (item) {
      this.modal_delete.boo = true;
      this.modal_delete.item = item;
    },
    close_delete: function () {
      this.modal_delete.boo = false;
    },
    mtd_commit: function () {
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/destroy",
        token: this.$store.getters.get__token,
        params: {
          id: this.modal_delete.item.Id,
        },
      })
        .then((response) => {
          this.mtd_getdata();
          this.modal_delete = {
            boo: false,
            item: [],
          };
          Swal.fire({
            title: "ELIMINADO CORRECTAMENTE",
            icon: "success",
          });
        })
        .catch((errors) => {});
    },
    changeSwitch: function (payload) {
      this.categories.state = payload == true ? 1 : 0;
    },


  },
};
</script>

<style lang="scss" scoped>
.btn-search {
  color: #fff;
  background-color: #2819ae;
  border-color: #2517a3;
}
</style>
